import ReactGA from 'react-ga4';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'sonner/dist/styles.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from './context/ThemeContext';

ReactGA.initialize(process.env.REACT_APP_GA4_MEASUREMENT_ID || 'G-JYR5V70W8C');
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
